import { render } from "./showAll.vue?vue&type=template&id=2ab8aaec&scoped=true"
import script from "./showAll.vue?vue&type=script&lang=ts"
export * from "./showAll.vue?vue&type=script&lang=ts"

import "./showAll.vue?vue&type=style&index=0&id=2ab8aaec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ab8aaec"

export default script